import {Link} from 'react-router-dom';
import {motion,useScroll,useTransform} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import ServiceCard from '../components/ServiceCard';
import Marquee from '../components/Marquee';
import ViewAllButton from '../components/ViewAllButton';
import {services} from '../data/services';
import './Home.css';

function Home() {
  const {scrollY}=useScroll();
  const heroY=useTransform(scrollY,[0,900],[0,180]);
  const heroOpacity=useTransform(scrollY,[0,700],[1,0.15]);
  return (
    <>
      <section className="hero">
        <motion.div className="hero-media" style={{y: heroY}} aria-hidden="true" />
        <div className="hero-shade" aria-hidden="true" />
        <div className="hero-light hero-light-one" aria-hidden="true" />
        <div className="hero-light hero-light-two" aria-hidden="true" />
        <motion.div className="hero-content" style={{opacity: heroOpacity}} initial={{opacity: 0,y: 45}} animate={{opacity: 1,y: 0}} transition={{duration: 1,ease: [0.22,1,0.36,1]}}>
          <span className="eyebrow hero-experience-label"> <i aria-hidden="true" /> 30 years of media experience </span>
          <h1> We create media <br /> that <em className="kinetic-word">moves.</em> </h1>
          <p> Strategy,craft,and technology working as one—turning ambitious ideas into unforgettable experiences. </p>
          <div className="hero-actions">
            <Link className="primary-button magnetic-button" to="/services">
              Explore our work <SafeIcon name="ArrowRight" aria-hidden="true" focusable="false" />
            </Link>
            <Link className="text-button showreel-link" to="/demos">
              <span aria-hidden="true"><SafeIcon name="Play" focusable="false" /></span> Play the showreel
            </Link>
          </div>
        </motion.div>
        <motion.div className="floating-reel" aria-hidden="true" animate={{y: [0,-12,0],rotate: [-2,2,-2]}} transition={{duration: 5,repeat: Infinity,ease: 'easeInOut'}}>
          <SafeIcon name="Play" focusable="false" />
          <span>Stories <br /> in motion</span>
        </motion.div>
        <div className="hero-index"> <span>EST.</span> <strong>1994</strong> </div>
        <div className="scroll-note" aria-hidden="true">Scroll to explore <i /></div>
      </section>
      <Marquee />
      <section className="statement">
        <motion.div initial={{opacity: 0,scale: 0.94}} whileInView={{opacity: 1,scale: 1}} viewport={{once: true}} transition={{duration: 0.8}}>
          <span className="section-tag">Built differently</span>
          <h2>Three decades of expertise. <br /><em>Infinite ways to create.</em></h2>
          <p>We are a full-service creative media partner bringing clarity,imagination,and technical excellence to every production.</p>
        </motion.div>
      </section>
      <section className="services-preview">
        <div className="section-head">
          <div>
            <span className="section-tag">Our capabilities</span>
            <h2>One partner. <br /> Every medium.</h2>
          </div>
          <ViewAllButton to="/services" />
        </div>
        <div className="service-grid">
          {services.slice(0,4).map((service,index)=> (
            <ServiceCard key={service.slug} service={service} index={index} />
          ))}
        </div>
      </section>
      <section className="experience-band" aria-label="Company statistics">
        <motion.div whileHover={{y: -8}}> <strong>30+</strong> <span>Years <br /> creating</span> </motion.div>
        <motion.div whileHover={{y: -8}}> <strong>8</strong> <span>Connected <br /> disciplines</span> </motion.div>
        <motion.div whileHover={{y: -8}}> <strong aria-label="Unlimited">∞</strong> <span>Creative <br /> possibilities</span> </motion.div>
      </section>
      <section className="closing-cta">
        <motion.div initial={{opacity: 0,y: 40}} whileInView={{opacity: 1,y: 0}} viewport={{once: true}}>
          <span className="eyebrow">Have a project in mind?</span>
          <h2>Let's make something <br /><em>remarkable.</em></h2>
          <Link to="/contact" className="primary-button magnetic-button">
            Start a conversation <SafeIcon name="ArrowUpRight" aria-hidden="true" focusable="false" />
          </Link>
        </motion.div>
      </section>
    </>
  );
}

export default Home;